import type React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { Badge, BadgeVariant } from '@components/ui/Badges'
import { OverflowTextWithTooltip } from '@oldComponents/OverflowTextWithTooltip'

const ExpiredBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
`

const StyledOverflowTextWithTooltip = styled(OverflowTextWithTooltip)`
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledBadge = styled(Badge)`
  margin-left: 4px;
`

interface ExpiredBadgeProps {
  children: NonNullable<React.ReactNode>
  expired: boolean
}

export function ExpiredBadge({ children, expired }: ExpiredBadgeProps) {
  return (
    <ExpiredBadgeWrapper>
      <StyledOverflowTextWithTooltip withPortal>{children}</StyledOverflowTextWithTooltip>
      {expired && (
        <StyledBadge variant={BadgeVariant.ERROR}>
          <FormattedMessage id="badges.expired" defaultMessage="Lejárt" />
        </StyledBadge>
      )}
    </ExpiredBadgeWrapper>
  )
}
